import React, { FC, MouseEvent } from "react";

import { Carousel } from "../../ActionsSelectors/Carousel";
import { Link } from "../../ActionsSelectors/Link";
import type { IProductItem } from "../ProductCard.interface";
import ProductPreviewItem from "./ProductPreviewItem/ProductPreviewItem";

export interface IProductPreviewsListProps {
  /**
   * The type used for Preview item presentation
   *
   * @type {IProductItem[]}
   */
  selectedItem: IProductItem;
  productItems: IProductItem[];

  /**
    function to get id of Product variant and set
    this variant as main
   */
  onItemHover?(id: string, event: MouseEvent): void;
  onItemClick?(id: string, event: MouseEvent): void;
}

const ProductPreviewsList: FC<IProductPreviewsListProps> = ({
  productItems,
  selectedItem,
  onItemHover,
  onItemClick,
}) => (
  <div
    className="product-card__preview-carousel"
    data-testid="ProductPreviewsList"
  >
    <Carousel variant="product-card-thumbnails-carousel">
      {productItems?.map((item) => (
        <Link {...item.link} key={item.id} classes={{ root: "d-block" }}>
          <ProductPreviewItem
            id={item.id}
            image={item.image}
            customImage={item.customImage}
            active={selectedItem.id === item.id}
            onHover={onItemHover}
            onClick={onItemClick}
          />
        </Link>
      ))}
    </Carousel>
  </div>
);

export default ProductPreviewsList;
